<template>
    <div class="blackBg animated bounceIn">
        <div class="cardTit">
            <span class="teamName">{{teamName?teamName:'XXX'}}</span>
            <!--            <span class="userName">{{this.$route.params.name}}</span>-->
        </div>
        <div class="cardBg">
            <p class="userName">{{this.$route.params.name}}</p>
            <div v-if="AIMItem.length" class="AIM-bar-content clearfix" id="cardBg" @click="clearTimeFn">
                <div class="barBox" v-for="(item, index) in AIMItem">
                    <div :key="index" class="AIM-bar-item" :id="'AIM-bar-'+index"></div>
                </div>
            </div>
            <div v-else style="line-height: 21vw;font-size: 26px;text-align: center;">暂无数据</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AC_AIM_Detail",
        computed: {
            teamId() {
                return this.$store.state.teamId;
            }
        },
        data() {
            return {
                teamName: this.$store.state.teamName ? this.$store.state.teamName.split('_')[0] : '',//梯队名称
                AIMData: [],
                AIMItem: [],
                weekData: [],//柱状图横坐标数据
                itemNum: [],//几条数据算出的柱状图
                time: null,//上下滚动定时器
                height: 1,
            }
        },
        mounted() {
            this.getFilter()

        },
        methods: {
            //  获取gps 筛选项
            getFilter() {
                let data = {
                    teamId: this.teamId
                }
                this.$server.getGpsFilter(data).then(res => {
                    if (res.code === 200) {
                        this.AIMItem = [];
                        if (res.data && res.data.length) {
                            let arr = [];
                            res.data.map(item => {
                                if (item.aim) {
                                    // console.log(item.slug)
                                    arr.push({
                                        ...item,
                                        playerNameAll: [],
                                        allData: [],
                                    })
                                }

                            })
                            this.AIMItem = arr;
                            this.AIMItem.length ? this.getAIM() : ''
                        }
                    }
                })
            },
            getAIM() {
                let data = {
                    playerId: this.$route.params.id,
                    teamId: this.teamId,
                    startDate: new Date().getFullYear() + '/01/01',
                    endDate: this.$global.formatDate(new Date(), 'yyyy/MM/dd', true)
                }
                this.$server.getAIMReport(data).then((res) => {
                    if (res.code == 200) {
                        this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
                        this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl("这是" + this.$route.params.name + '的ac目标报告'), true, false)

                        let GPSData = res.data;

                        this.weekData = [];
                        this.AIMItem.forEach((item, index) => {
                            item.allData = [];
                            item.increase = [];
                            if (index == 0) {
                                item.check = true;
                            } else {
                                item.check = false;
                            }
                        });

                        if (GPSData != null && GPSData != undefined && GPSData.length > 0) {
                            GPSData.forEach(item => {
                                this.weekData.push('W' + item.weekIndex)

                                this.AIMItem.forEach(gps => {
                                    item.data = item.data || []
                                    const currentGps = item.data.find(dataValue => dataValue.slug === gps.slug)
                                    if (currentGps && currentGps.value) {
                                        gps.allData.push({
                                            value: Number(currentGps.value).toFixed(gps.decimal),
                                            increase: currentGps.increase, // 百分比
                                            timeFormat: gps.timeFormat,
                                            name: gps.displayName
                                        })
                                    } else {
                                        gps.allData.push({
                                            value: '',
                                            increase: '', // 百分比
                                            timeFormat: gps.timeFormat,
                                            name: gps.displayName
                                        })
                                    }
                                })
                            })

                            //默认显示
                            setTimeout(() => {
                                this.AIMItem.forEach((item, index) => {
                                    this.AIMItem[index].check = true;
                                    this.AIMBar(this.AIMItem[index], 'AIM-bar-' + index);
                                })

                                this.scroll()
                            }, 500)
                        }
                    }
                })
            },
            //echarts图
            AIMBar(data, id) {
                let dom = document.getElementById(id);
                let lookDom = document.querySelector('#' + id)
                let myChart = this.$echarts.init(dom);

                //柱状图显示宽度
                if (parseInt(lookDom.offsetWidth) > (80 * data.allData.length)) {
                    dom.style.width = (parseInt(lookDom.offsetWidth) - 10) + 'px';
                } else {
                    dom.style.width = (80 * data.allData.length) + "px";
                }
                myChart.resize();
                let option = null;

                option = {
                    title: {
                        text: data.name,
                        textStyle: {
                            color: '#fff',
                            fontSize: 22,
                            fontWeight: null
                        },
                        left: '20',
                        top: '10'
                    },
                    color: ['#5FA0D7'],
                    grid: {
                        top: '20%',
                        left: '30',
                        right: '0',
                        bottom: '7%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            axisLine: {
                                show: true,  // 是否显示
                                lineStyle: {
                                    color: '#666',
                                    opacity: '0.5',
                                    type: 'solid'
                                },
                            },
                            axisLabel: {
                                interval: 0,
                                color: '#fff',
                                fontSize:14
                            },
                            splitLine: {
                                lineStyle: {
                                    color: '#666',
                                    opacity: '0.3',
                                    type: 'dotted'
                                },
                                show: false
                            },
                            data: this.weekData
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            axisLabel: {
                                color: '#fff',
                                fontSize:14
                            },
                            axisLine: {
                                show: false,  // 是否显示
                            },
                            splitLine: {
                                lineStyle: {
                                    color: '#666',
                                    opacity: '0.3',
                                    type: 'dotted'
                                },
                                show: true
                            },
                        },
                    ],
                    series: [
                        {
                            name: data.name,
                            type: 'line',
                            areaStyle: {
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(129, 181, 255, 0.6)'
                                }, {
                                    offset: 1,
                                    color: 'rgba(129, 181, 255, 0.1)'
                                }]),
                            },
                            itemStyle: {    // 图形的形状
                                normal: {
                                    color: 'var(--primary-color)',
                                    lineStyle: {
                                        width: 1,
                                        // type:'dotted'  //'dotted'虚线 'solid'实线
                                    }
                                }
                            },
                            label: {
                                position: 'top',
                                show: true,
                                formatter:  (params) => {
                                    let number = params.value;
                                    let increase = params.data.increase
                                    let html = '{label|' + increase + ' ' + '}\n' + `{normal|${number}}`

                                    if(increase){
                                        if(increase.substr(0,1)=='-'){
                                            html= '{num|' + increase + ' ' + '}\n' + `{normal|${number}}`
                                        }
                                    }
                                    return html
                                },
                                rich: {
                                    label: {
                                        align: 'center',
                                        color: '#65B168',// 工艺等文字颜色
                                        fontFamily: 'PingFang',
                                        fontSize: 14,
                                        marginBottom: 5
                                    },
                                    num: {
                                        align: 'center',
                                        color: '#F95C51',
                                        fontFamily: 'PingFang',
                                        marginBottom: 5
                                    },
                                    normal: {
                                        align: 'center',
                                        color: '#fff',
                                        fontFamily: 'PingFang',
                                    }
                                },
                                distance: 5,
                            },
                            //鼠标悬停时：
                            emphasis: {
                                //柱形图圆角，初始化效果
                                barBorderRadius: [2, 2, 0, 0],
                                label: {
                                    rich: {
                                        label: {
                                            fontSize: '16',
                                            fontWeight: '600',
                                        },
                                        num: {
                                            fontSize: '16',
                                            fontWeight: '600',
                                            color: 'red',
                                        },
                                    }
                                }

                            },
                            data: data.allData,
                        }
                    ]
                };

                if (option && typeof option === "object") {
                    myChart.setOption(option, true);
                }

            },
            //滚动数据
            scroll() {
                var hScrollTop = document.getElementById('cardBg').scrollTop;
                var hScrollHeight = document.getElementById('cardBg').scrollHeight;
                var offsetHeight = document.getElementById('cardBg').offsetHeight;

                // console.log(hScrollTop + " " + hScrollHeight + " " + this.height + ' ' + offsetHeight);
                if ((offsetHeight + hScrollTop) >= hScrollHeight) {//滚动条已经到了容器底部
                    this.height = -1;
                }else if (hScrollTop === 0) {
                    this.height = 1;
                }

                var h = hScrollTop + this.height;
                document.getElementById('cardBg').scrollTop = h;
                this.time = window.requestAnimationFrame(this.scroll)
            },
            clearTimeFn() {
                console.log('执行取消事件')
                window.cancelAnimationFrame(this.time)
                return false;
            },
        },
        destroyed() {
            window.cancelAnimationFrame(this.time)

        }
    }
</script>

<style scoped lang="less">
    .cardTit {
        background-image: url("../../assets/img/updateImg/head_2.png");
        font-size: 30px;
        box-sizing: border-box;
        position: relative;

        .season, .userName {
            font-family: PingFangMedium;
            color: #fff;
            display: inline-block;
            line-height: 120px;
            position: absolute;
        }

        .season {
            line-height: 130px;
            left: 2vw;
        }

        .userName {
            right: 2vw;
            color: var(--primary-color);
            font-size: 36px;
        }
    }

    .cardBg {
        width: 100%;
        height: calc(100% - (120px + 1.2vw));
        padding: 1vw;
        box-sizing: border-box;
        overflow: hidden;

        .userName {
            color: var(--primary-color);
            font-size: 36px;
            height: 3vw;
            line-height: 2vw;
            padding-left: 1vw;
        }
    }

    .AIM-bar-content {
        width: 100%;
        height: calc(100% - 3vw);
        overflow-y: auto;

        .barBox {
            width: 100%;
            height: 450px;
            overflow-y: hidden;
            overflow-x: hidden;
            margin-top: 1.5vw;

            .AIM-bar-item {
                height: 100%;
                width: 100%;
            }
        }

        .scrollX {
            overflow-x: scroll;
        }
    }
</style>
